export async function generateFingerprint(): Promise<{
  rawData: Record<string, any>;
  fingerprint: string;
}> {
  const data = {
    userAgent: navigator.userAgent,
    language: navigator.language,
    platform: navigator.platform,
    vendor: navigator.vendor,
    screenResolution: `${screen.width}x${screen.height}`,
    colorDepth: screen.colorDepth,
    pixelRatio: window.devicePixelRatio,
    plugins: Array.from(navigator.plugins).map(plugin => plugin.name).join(','),
    mimeTypes: Array.from(navigator.mimeTypes).map(type => type.type).join(','),
    timezoneOffset: new Date().getTimezoneOffset(),
    touchSupport: navigator.maxTouchPoints,
    deviceMemory: (navigator as any).deviceMemory || 'unknown',
    canvas: getCanvasFingerprint(),
    webgl: getWebGLFingerprint(),
  };

  const fingerprint = await hashData(JSON.stringify(data));
  return { rawData: data, fingerprint };
}

function getCanvasFingerprint(): string {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) return 'unknown';

  ctx.textBaseline = 'top';
  ctx.font = '14px Arial';
  ctx.fillStyle = '#f60';
  ctx.fillRect(0, 0, 100, 100);
  ctx.fillStyle = '#069';
  ctx.fillText('Browser Fingerprint', 10, 50);
  return canvas.toDataURL();
}

function getWebGLFingerprint(): string {
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl') as WebGLRenderingContext | null
    || canvas.getContext('experimental-webgl') as WebGLRenderingContext | null;
  if (!gl) return 'unknown';

  const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
  return debugInfo
    ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
    : 'unknown';
}

export async function hashData(data: string): Promise<string> {
  const encoder = new TextEncoder();
  const dataBuffer = encoder.encode(data);
  const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
}
